<!-- 养护添加 -->
<template>
   <div>
      <div class="demo-drawer__content data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
               <template slot="tabs" slot-scope="scope">
                  <div class="table_content_box">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0">
                        <el-form label-width="100px" id="mainInfo" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini" :disabled="dataActionBox.actionType == 2">
                           <el-row v-if="dataActionBox.actionType!=2">
                              <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                 <!-- 检索方案 -->
                                 <el-input v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]"
                                           @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                    <el-button :disabled="formOneValue.isChange == 0"
                                               @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                               icon="el-icon-search"></el-button>
                                 </el-input>
                                 <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                            v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                    </el-option>
                                 </el-select>
                                 <!-- 日期 -->
                                 <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                          :isShowLong="false" :isdisabled="formOneValue.isChange == 0 ">
                                 </df-date>
                                 <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0">
                                 </el-input>
                              </el-form-item>
                           </el-row>
                           <el-row v-if="dataActionBox.actionType==2">
                              <el-form-item :label="formOneValue.showField+':'" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                 <span v-if="formOneValue.fieldType == 'date'">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                                 <span v-else-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                       getValue(sendDataInfo[formOneValue.entityField],
                                          formOneValue.entityField, formOneValue.fieldType,
                                          formOneValue.formatterContent) }}</span>
                                 <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
         <!-- 页脚 -->
         <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="false" :footFlag="false" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                 @showPrintPlan="showPrintPlan"></v-foot>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
   name: "salesCommissionAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         detaislDataInfo: {},
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         tabForm: [],
         mxForm: [],
         footForm: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         mxHeight: 400,
         parentSearchData: {},
         sField: '',
         seType: '',
         fField: "",
         inputel: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.cmName"(){
         if (this.sendDataInfo.cmName=="") {
            this.sendDataInfo.cmId =""
         }
      }
   },
   //方法集合
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'smIntype') {
            this.dictionariesDatas.forEach(item => {
               if (item.diValue === val) {
                  str = item.diName
               }
            })
         } else if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value === val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key === val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      // 打印方法
      showPrintPlan() {
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField, fField) {
         this.focusIndex = index;
         this.sField = sField
         this.fField = fField
         this.seType = type
         this.seId = sId;
         if (type=='bgmName') {
            if (this.sendDataInfo.cmId==""||this.sendDataInfo.cmName=='') {
               return this.$message.error('请先选择客户！')
            }
            this.parentSearchData.cmId = this.sendDataInfo.cmId
         }
         this.parentSearchData[type] = this.sendDataInfo[type]
         this.DialogVisible = true;
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         console.log(this.sField)
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.focusIndex, this.fField);
         });
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               return false;
            }
         });
         if (flag) return false;
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.bgmPrcaddOrder(sendData);
         } else {
            var responseData = await this.$http.bgmPrcupdateOrder(sendData);
         }
         if (responseData.status == 200) {
            this.$emit("drawerCancel", true);
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(formName) {
         this.$emit("drawerCancel");
      },
      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量

         this.sendDataInfo.lomApptype = 0;
      },
      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            this.sendDataInfo.lossdetailAdds = [];
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         } else if (this.dataActionBox.actionType == 2) {
            this.dataActionBox.boxTitle = "查看信息";
            this.sendDataInfo.lossdetailAdds = [];
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus();
            }, 16.7)
         });
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },

      // 输入框切换焦点
      nextFocus(index, fField) {
         if (index >= this.inputel.length - 1) {
            return;
         }
         if (fField == "keydown") {
            return;
         }
         var aindex = index + 1;
         if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
            this.nextFocus(aindex);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },

      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               // if (key.jurconfigform[index].isShow == 1)
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

            }
         });
         var arr = []
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}

::v-deep .el-form-item__content {
   width: 200px;
}
</style>